import React from 'react';
import { ArchiveIcon, CheckCircle2Icon, PlusIcon } from 'lucide-react';
import { settingsActions, useSettingsStore } from '../../data/settingsStore';
type CatalogManagementTabProps = {
  onAdd: () => void;
};
export function CatalogManagementTab({
  onAdd
}: CatalogManagementTabProps) {
  const {
    departments
  } = useSettingsStore();
  const availabilityMessage = 'Archived departments remain visible for historical records.';
  return <section className="overflow-hidden rounded-xl border border-slate-200" data-id="element-290" data-mp="3oqwv41x4bwqm">
      <div className="flex flex-col gap-3 border-b border-slate-200 bg-white px-4 py-4 sm:flex-row sm:items-center sm:justify-between md:px-5" data-id="element-291" data-mp="3tphlzaqhd42e">
        <div data-id="element-292" data-mp="2dyavtqjpyhh">
          <h2 className="text-base font-semibold text-slate-900" data-id="element-293" data-mp="7ayi47z4t7a6">Departments</h2>
          <p className="mt-0.5 text-sm text-slate-500" data-id="element-294" data-mp="7d150j4zmkao">{availabilityMessage}</p>
        </div>
        <button type="button" onClick={onAdd} className="inline-flex items-center justify-center gap-2 rounded-lg bg-[#14466B] px-4 py-2.5 text-sm font-medium text-white shadow-sm transition-colors hover:bg-[#0F3D5C] focus:outline-none focus:ring-2 focus:ring-blue-200 focus:ring-offset-2" data-id="element-295" data-mp="c7yefr66ivo3">
          <PlusIcon className="h-4 w-4" data-id="element-296" data-mp="36lm4hbh18li7" />
          Add department
        </button>
      </div>
      <div className="overflow-x-auto" data-id="element-297" data-mp="31mssxolb34ko">
        <table className="min-w-[620px] w-full text-left" data-id="element-298" data-mp="31o2rsfzzggsd">
          <thead className="border-b border-slate-200 bg-slate-50" data-id="element-299" data-mp="34vuymm8rqbr">
            <tr data-id="element-300" data-mp="3789epssjik2">
              <th className="px-4 py-3 text-xs font-semibold uppercase tracking-wider text-slate-500" data-id="element-301" data-mp="3ubggjqtj261e">
                Name
              </th>
              <th className="px-4 py-3 text-xs font-semibold uppercase tracking-wider text-slate-500" data-id="element-302" data-mp="3pjop7e2jrwa7">
                Status
              </th>
              <th className="px-4 py-3 text-right text-xs font-semibold uppercase tracking-wider text-slate-500" data-id="element-303" data-mp="3kjsvc7nkdl8d">
                Action
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100 bg-white" data-id="element-304" data-mp="h2tuwmztfk7q">
            {departments.map(department => {
            const status = department.status;
            return <tr key={department.id} className="hover:bg-slate-50" data-id="element-305" data-mp="2gbbvcrzl0n8j">
                  <td className="px-4 py-3 text-sm font-medium text-slate-900" data-id="element-306" data-mp="21lxobqjhahwb">
                    {department.name}
                  </td>
                  <td className="px-4 py-3" data-id="element-307" data-mp="26jz6m992yd6q">
                    <StatusBadge status={status} data-id="element-308" data-mp="1sm15w6nomf9p" />
                  </td>
                  <td className="px-4 py-3 text-right" data-id="element-309" data-mp="1wnw77b5m4snh">
                    <button type="button" onClick={() => {
                  settingsActions.toggleDepartmentStatus(department.id);
                }} className={`inline-flex items-center gap-1.5 rounded-lg border px-3 py-1.5 text-xs font-medium transition-colors ${status === 'active' ? 'border-amber-200 text-amber-700 hover:bg-amber-50' : 'border-emerald-200 text-emerald-700 hover:bg-emerald-50'}`} data-id="element-310" data-mp="1wpfnh1r9r3p9">
                      {status === 'active' ? <ArchiveIcon className="h-3.5 w-3.5" data-id="element-311" data-mp="11f0z0vkncgqy" /> : <CheckCircle2Icon className="h-3.5 w-3.5" data-id="element-312" data-mp="1g3opwojjs2ak" />}
                      {status === 'active' ? 'Archive' : 'Reactivate'}
                    </button>
                  </td>
                </tr>;
          })}
          </tbody>
        </table>
      </div>
    </section>;
}
function StatusBadge({
  status
}: {
  status: 'active' | 'archived';
}) {
  return <span className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium ${status === 'active' ? 'bg-emerald-50 text-emerald-700' : 'bg-slate-100 text-slate-600'}`} data-id="element-313" data-mp="1z29dw7q56rjz">
      <span className={`h-1.5 w-1.5 rounded-full ${status === 'active' ? 'bg-emerald-500' : 'bg-slate-400'}`} data-id="element-314" data-mp="4o8dvjiuvyib" />
      {status === 'active' ? 'Active' : 'Archived'}
    </span>;
}